import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

export const SimpleButton = (props) => {
  // console.log('SimpleButton props', props);
  const {
    label,
    size,
    link,
    href,
    color,
    secondary,
    primary,
    outlined,
    raised,
    disabled,
    endIcon,
    startIcon,
    className,
    onClick,
    target,
    ...rest
  } = props;

  let variant = raised ? 'contained' : 'text';
  let finalColor = color;

  if (secondary) {
    finalColor = 'secondary';
  }
  if (primary) {
    finalColor = 'primary';
  }
  if (outlined) {
    variant = 'outlined';
  }

  return (
    <Button
      variant={variant}
      color={finalColor}
      size={size}
      disabled={disabled}
      href={href || link} // backward compatibility
      target={target}
      endIcon={endIcon}
      startIcon={startIcon}
      onClick={onClick}
      className={className}
      {...rest}
    >
      {label}
    </Button>
  );
};

SimpleButton.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  raised: PropTypes.bool,
  secondary: PropTypes.bool,
  primary: PropTypes.bool,
  outlined: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  endIcon: PropTypes.node,
  startIcon: PropTypes.node,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  target: PropTypes.oneOf(['_blank', '_self', '_top']),
};

SimpleButton.defaultProps = {
  size: 'medium',
  color: 'inherit',
  label: 'Insert Label',
  link: '',
  href: '',
  raised: false,
  secondary: false,
  primary: false,
  outlined: false,
  disabled: false,
  onClick: () => {},
  endIcon: null,
  startIcon: null,
  className: null,
  target: null,
};
